import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b8f5140&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b8f5140&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8f5140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/syx-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8f5140')) {
      api.createRecord('4b8f5140', component.options)
    } else {
      api.reload('4b8f5140', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b8f5140&scoped=true", function () {
      api.rerender('4b8f5140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYQuillEditor/index.vue"
export default component.exports